import { RootState } from "store/store";
import CustomerFilters from "./CustomerFilters";
import { connect } from "react-redux";
import {
    getCustomerFilterStatus,
    getCustomerStatusCalculated,
} from "store/filters/filters-selectors";
import {
    setCustomerFilterStatus,
    setCustomersFilterStatusCalculated,
} from "store/filters/filters-actions";
import { getCustomers } from "store/customers/customers-selectors";

const mapStateToProps = (state: RootState) => {
    return {
        customerFilterStatus: getCustomerFilterStatus(state),
        isStatusCalculated: getCustomerStatusCalculated(state),
        customers: getCustomers(state),
    };
};
const CustomerFiltersContainer = connect(mapStateToProps, {
    setCustomerFilterStatus,
    setCustomersFilterStatusCalculated,
})(CustomerFilters);

export default CustomerFiltersContainer;
